import React, { useState } from "react";
import {
  BGColor02,
  blackShade19,
  copyBtnColor,
  greyColor40,
  lightGreen04,
  lightGreen17,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import {
  Box,
  Typography,
  Chip,
  Button,
  Paper,
  Divider,
  Stack,
  Grid,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ModalCard from "../../../components/ModalCard";

function CategoryInfoCard({ activeBusinessInfo }) {
  const [openModel, setOpenModel] = useState(null);
  return (
    <Stack
      gap={2}
      sx={{
        p: "10px 12px",
        background: lightGreen04,
        border: "1px solid " + lightGreen17,
        borderRadius: "8px",
      }}
    >
      <CategoryListWithHeader
        title="ONDC CATEGORIES"
        categories={activeBusinessInfo?.businessONDCCategories || []}
        handleClickMore={() =>
          setOpenModel({
            show: true,
            data: {
              title: "ONDC CATEGORIES",
              categories: activeBusinessInfo?.businessONDCCategories || [],
            },
          })
        }
      />
      <CategoryListWithHeader
        title="WEBSTORE CATEGORIES"
        categories={activeBusinessInfo?.businessCategories || []}
        handleClickMore={() =>
          setOpenModel({
            show: true,
            data: {
              title: "WEBSTORE CATEGORIES",
              categories: activeBusinessInfo?.businessCategories || [],
            },
          })
        }
      />

      <CategoryListModel
        openModal={openModel?.show}
        setOpenModal={setOpenModel}
        categoryData={openModel?.data}
      />
    </Stack>
  );
}

export default CategoryInfoCard;

const CategoryListWithHeader = ({ title, categories, handleClickMore }) => {
  return (
    <Stack gap={0.5}>
      <Typography
        fontSize={11.2}
        lineHeight="14px"
        fontWeight={500}
        color={greyColor40}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          rowGap: 1,
          columnGap: 4,
        }}
      >
        {categories?.length == 0 && (
          <Typography
            fontSize={12}
            lineHeight="20px"
            fontWeight={500}
            color={blackShade19}
          >
            N/A
          </Typography>
        )}
        {categories?.slice(0, 3)?.map((item, i) => (
          <CategoryText key={i} text={item?.name} />
        ))}

        {categories?.length > 3 && (
          <Button
            size="small"
            sx={{
              ml: 1,
              color: copyBtnColor,
              fontSize: "11px",
              textTransform: "none",
              fontWeight: 500,
              p: 0,
              textDecoration: "underline",
              minWidth: "auto",
              "&:hover": {
                background: "transparent",
              },
            }}
            onClick={handleClickMore}
          >
            Click More
          </Button>
        )}
      </Box>
    </Stack>
  );
};

const CategoryText = ({ text }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <FiberManualRecordIcon sx={{ fontSize: 8, mr: 1, color: blackShade19 }} />
      <Typography
        fontSize={12}
        lineHeight="20px"
        fontWeight={500}
        color={blackShade19}
      >
        {text}
      </Typography>
    </Box>
  );
};

const CategoryListModel = ({ openModal, setOpenModal, categoryData }) => {
  return (
    <ModalCard
      open={openModal}
      handleClose={() => {
        setOpenModal(null);
      }}
      width="30%"
    >
      <Box sx={{ backgroundColor: whiteColor, borderRadius: 1.8 }}>
        <Box
          sx={{
            backgroundColor: BGColor02,
            p: 1.5,
            borderRadius: "14.4px 14.4px 0 0",
            textAlign: "center",
          }}
        >
          <Typography
            variant="body1"
            fontSize={16}
            fontWeight={600}
            color={blackShade19}
            mb={0.3}
          >
            {categoryData?.title}
          </Typography>
        </Box>

        <Box sx={{ p: "10px 15px 15px 15px" }}>
          <Grid container spacing={1}>
            {categoryData?.categories?.map((item, index) => (
              <Grid item xs={6} key={index}>
                <CategoryText text={item?.name} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </ModalCard>
  );
};
